export const formatToItalianCurrency = (amount) => {
  const num = Number(amount);

  return num.toLocaleString('it-IT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};